import { render, staticRenderFns } from "./piccontribution.vue?vue&type=template&id=202d62a2&scoped=true&"
import script from "./piccontribution.vue?vue&type=script&lang=js&"
export * from "./piccontribution.vue?vue&type=script&lang=js&"
import style0 from "./piccontribution.vue?vue&type=style&index=0&id=202d62a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d62a2",
  null
  
)

export default component.exports